<div class="container-fluid registro-ausencias">

  <div class="ra-header rounded">
    <div class="row align-items-center">
      <div class="col-md-1 text-center"><i class="fa-solid fa-clipboard-user fa-2xl"></i></div>
      <div class="col-md-11">
        <div class="ra-header-title">REGISTRO DE AUSENCIAS</div>
        <div class="ra-header-sub">{{ header.M05DES }}</div>
      </div>
    </div>
  </div>

  <div class="ra-context">
    <div class="row">
      <div class="col-md-7">
        <div class="ra-context-line"><b>{{ header.M11COD }}</b> {{ header.M11DES }} - Grupo {{ header.M23GRU }}</div>
        <div class="ra-context-line"><b>Periodo:</b> {{ header.M19DES || header.M19COD }}</div>
        <div class="ra-context-line"><b>Profesor:</b> {{ header.PROFESOR_NOM }} <span *ngIf="header.PROFESOR_COD">(#{{ header.PROFESOR_COD }})</span></div>
      </div>
      <div class="col-md-5 ra-reportes" *ngIf="reportes.length > 0">
        <button *ngFor="let r of reportes"
                type="button"
                class="btn btn-link ra-reporte-btn"
                (click)="imprimirReporte(r)">
          <i *ngIf="r.SYS21ICO" class="fa {{ r.SYS21ICO }}"></i>
          {{ r.SYS10DES }}
        </button>
      </div>
    </div>
  </div>

  <div class="ra-toolbar">

    <div class="ra-filtros">
      <div class="ra-filtro">
        <label class="ra-label">Tipo a registrar:</label>
        <ng-select [items]="tiposAusencia"
                   bindLabel="label" bindValue="value"
                   [(ngModel)]="tipoSeleccionado"
                   placeholder="-- Seleccione --"
                   [clearable]="false">
        </ng-select>
      </div>
      <div class="ra-filtro">
        <label class="ra-label">Clases del Mes:</label>
        <ng-select [items]="meses"
                   bindLabel="label" bindValue="value"
                   [ngModel]="mesActual"
                   (change)="cambiarMes($event?.value)"
                   placeholder="-- Mes --"
                   [clearable]="false">
        </ng-select>
      </div>
      <div class="ra-filtro ra-buscador">
        <label class="ra-label">Carné o nombre:</label>
        <input type="text" class="form-control form-control-sm"
               [(ngModel)]="buscaCarne"
               (keypress)="buscarCarne($event)">
      </div>
    </div>
  </div>

  <div class="ra-table-wrap" *ngIf="!cargando; else loading">
    <table class="table table-bordered table-sm ra-matriz">
      <thead class="table-light">
        <tr>
          <th class="ra-col-fija">#</th>
          <th class="ra-col-fija">Carnet</th>
          <th class="ra-col-fija">Nombre</th>
          <th *ngFor="let col of columnas" [title]="col.E21FEC">{{ col.E21FEC }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let est of estudiantes; let i = index"
            [class.ra-fila-activa]="filaActiva === i">
          <td>{{ i + 1 }}</td>
          <td>{{ est.M12CAR }}</td>
          <td class="text-start">{{ est.M12NOM }}</td>

          <td *ngFor="let col of columnas"
              class="ra-celda"
              [class.ra-celda-clickable]="permisos.GRABAR === 'S'"
              [class.ra-celda-A]="ausenciaDe(est, col) === 'A'"
              [class.ra-celda-J]="ausenciaDe(est, col) === 'J'"
              (click)="marcarFila(i); toggleAusencia(est, col)">
            {{ ausenciaDe(est, col) || '—' }}
          </td>
        </tr>
        <tr *ngIf="estudiantes.length === 0">
          <td [attr.colspan]="columnas.length + 3" class="text-center">
            No se encuentran estudiantes registrados
          </td>
        </tr>
        <tr *ngIf="estudiantes.length > 0 && columnas.length === 0">
          <td [attr.colspan]="3" class="text-center">
            No hay clases impartidas para el mes seleccionado
          </td>
        </tr>
      </tbody>
    </table>
    <div class="ra-leyenda">A: Injustificada &nbsp;|&nbsp; J: Justificada</div>
  </div>

  <ng-template #loading>
    <div class="text-center py-4">
      <i class="fa fa-spinner fa-spin fa-2xl"></i>
      <div>Cargando matriz de ausencias...</div>
    </div>
  </ng-template>

</div>
